import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faChevronDown } from '@fortawesome/free-solid-svg-icons'

import { SearchResultType } from '@monorepo/interfaces'
import { Search } from '@monorepo/deprecated/hooks'

type OffersControlProps = {
  item: SearchResultType
}

export const OffersControl: React.FC<OffersControlProps> = ({ item }) => {
  const { collapseHandler, expandHandler } = Search.useOffersControl(item.good)

  return (
    <div className="d-flex justify-content-end w-100 mt-1 mb-1">
      {item.meta.isExpanded && (
        <Button
          variant="link"
          size="sm"
          onClick={collapseHandler}
          className="font-weight-lighter text-reset"
        >
          Свернуть <FontAwesomeIcon icon={faChevronDown} rotation={180} />
        </Button>
      )}
      {item.meta.isExpanded && item.meta.isHasMoreOffers && <> | </>}
      {item.meta.isHasMoreOffers && (
        <Button
          variant="link"
          size="sm"
          onClick={expandHandler}
          className="font-weight-lighter text-reset"
          disabled={item.meta.isLoading}
        >
          <FormattedMessage
            id="pages.cart.more_offers"
            values={{
              amount: item.meta.totalOffers - item.offers.length,
            }}
          />{' '}
          <FontAwesomeIcon
            icon={item.meta.isLoading ? faCircleNotch : faChevronDown}
            spin={item.meta.isLoading}
          />
        </Button>
      )}
    </div>
  )
}
